import graphQl from '../../../../services/graphQl';
import { AxiosResponse } from 'axios';
import { ActionTree } from 'vuex';
import { State } from './detail.store';
import { Context } from '@/utils/types/global';
import { isArray } from 'lodash';

const actions: ActionTree<State, any> = {
  getWSMInstances(
    context: Context,
    params: { serviceId: any; properties: any }
  ) {
    return graphQl
      .query('queryServiceInstances')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit('setWSMInstances', res.data.data.instanceId);
        if (res.data.data.instanceId.length > 0) {
          const curIns = res.data.data.instanceId.find(
            ins =>
              ins.key ===
              context.rootState.wsmState.detail.currentWSMInstance.key
          );
          const instance = curIns || res.data.data.instanceId[0];
          context.commit('setCurrentWSMInstance', instance);
          if (instance && isArray(instance.attributes)) {
            instance.attributes.forEach(attribute => {
              if (attribute['name'] === 'instance_type') {
                const subType = {
                  key: attribute['value'],
                  value: attribute['value']
                };
                context.commit('setCurrentSubType', subType);
              }
            });
          }
        } else {
          context.commit('setCurrentWSMInstance', '');
        }
      });
  }
};

export default actions;
